export const classTypeToUrlSlugResolver = (classType) => {
  switch (classType) {
    case "ProjectTemplate":
      return "project-template";
    case "UserCalendar":
    case "ExternalCalendar":
      return "calendar";
    case "CalendarEvent":
      return "calendar-event";
    case "Folder":
      return "folder";
    case "Comment":
      return "comment";
    case "Expense":
      return "expense";
    case "TimeRecord":
      return "time-record";
    case "Subtask":
      return "subtask";
    case "Task":
      return "task";
    case "TaskList":
      return "task-list";
    case "Discussion":
      return "discussion";
    case "Project":
      return "project";
    case "Note":
      return "note";
    case "Notebook":
      return "notebook";
    case "Owner":
    case "Member":
    case "Client":
      return "user";
    case "LocalFile":
    case "WarehouseFile":
    case "DropboxFile":
    case "GoogleDriveFile":
      return "file";
    case "Company":
      return "company";
    case "Estimate":
      return "estimate";
    case "Invoice":
      return "invoice";
    case "RecurringTask":
      return "recurring-task";
    case "ActiveCollab\\Module\\System\\Model\\Folder\\ProjectFolder":
      return "project-folder";
    default:
      return "";
  }
};
